import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { Collapse, DatePicker, Menu, message, Modal, Select, Spin } from "antd";
import {
  AppstoreOutlined,
  DeleteOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { InputField } from "./input-field";
import { caseStatus } from "store/atom";
import { useRecoilState } from "recoil";
import {
  AccordianDropdownArrow,
  AlertWhiteIcon,
  CalenderIcon,
  DeleteIconRed,
  DropdownSuffix,
  PencilIcon,
} from "icons";
import { ConditionalRenderer } from "components";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { ReminderHistoryTable } from "./reminderHistoryTable";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { formFields } from "pages/cases-detail/constants";
import { FileNumberSmile } from "../file-number-smile";
import { useCurrentUserContext } from "providers";
import dayjs from "dayjs";
import { AddTemplate } from "./add-template";

const CaseReminder = ({
  caseId,
  setShowNewTemplate,
  showNewTemplate,
  employees,
  refetchCount,
  caseTotalStatuses,
  caseStatus,
  caseStatusLocal,
  setCaseStatusLocal,
}) => {
  const { translator } = useLanguageTranslator();
  const [reminders, setReminders] = useState([]);

  const [filtersData, setFiltersData] = useState({
    dueDate: null,
    createdBy: null,
    assignedTo: null,
    status: null,
    category: null,
  });

  const [focused, setFocused] = useState(false);

  const { user } = useCurrentUserContext();
  const Fields = formFields?.map((item) => {
    return {
      value: item.key,
      label: `${item.id}. ${translator(`caseDetail.form.${item?.key}`)}`,
      id: item?.id,
    };
  });
  const [activeKey, setActiveKey] = useState();
  const [templateId, setTemplateId] = useState(null);
  const [category, setCategory] = useState(Fields[0].value);
  const [categoryNum, setCategoryNum] = useState(Fields[0].id);

  const [selectedCategoryTemplates, setSelectedCategoryTemplates] = useState();
  const childrenForSidebar = selectedCategoryTemplates?.map((item) => {
    return {
      key: String(item?.id),
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 10px 0 0",
          }}
        >
          <span
            className={styles.sidebarTitle}
            style={{
              maxWidth: "230px",
              overflow: "hidden",
              wordBreak: "break-all",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {item?.title}
          </span>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <PencilIcon
              onClick={() => {
                const selectedTemplate = templatesData?.templates?.find(
                  (child) => JSON.parse(child?.id) === JSON.parse(item?.id),
                );

                const { category, title, subject, description } =
                  selectedTemplate || {};
                setReminderFormData({
                  category,
                  title,
                  subject,
                  description,
                });
                setTemplateId(JSON.stringify(item?.id));
                setShowNewTemplate(true);
              }}
            />
            <DeleteIconRed
              onClick={(e) => {
                e.stopPropagation(); // important
                handleDelete(item?.id);
              }}
              style={{ color: "red" }}
            />
          </div>
        </div>
      ),
    };
  });

  const [current, setCurrent] = useState(
    childrenForSidebar?.[0]?.key
      ? JSON.stringify(childrenForSidebar?.[0]?.key)
      : null,
  );

  const reminderTrans = translator("caseDetail.reminder");
  const reminderFormTrans = translator("caseDetail.reminder.form");
  // const [caseStatusOpenOrClosed, setCaseStatusOpenOrClosed] =
  //   useRecoilState(caseStatus);
  const [reminderFormData, setReminderFormData] = useState({
    name: null,
    email: null,
    // name: employees?.[0]?.label,
    // email: employees?.[0]?.value,
    title: "",
    subject: "",
    description: "",
  });

  const [error, setError] = useState({
    name: false,
    email: false,
  });

  const [
    get_email_reminders,
    {
      data: reminderHistory,
      isLoading: reminderHistoryLoading,
      refetch: refetchReminderHistory,
    },
  ] = UseLazyApiCallV2({
    url: "/get_email_reminders",
    method: "POST",
    skip: !caseId,
    paramsData: {
      case_id: caseId,
      filters: filtersData,
    },
  });

  // const {
  //   data: reminderHistory,
  //   isLoading: reminderHistoryLoading,
  //   refetch: refetchReminderHistory,
  // } = UseApiCallV2({
  //   url: "/get_email_reminders",
  //   method: "POST",
  //   skip: !caseId,
  //   paramsData: {
  //     case_id: caseId,
  //     filters: filtersData,
  //   },
  // });

  const [
    addTemplate,
    {
      data: addTemplateData,
      isLoading: addTemplateLoading,
      error: addTemplateError,
    },
  ] = UseLazyApiCallV2({
    url: "/add_template",
    method: "POST",
  });
  const [
    setReminder,
    {
      data: setReminderData,
      isLoading: setReminderLoading,
      error: setReminderError,
    },
  ] = UseLazyApiCallV2({
    url: "/set_reminder",
    method: "POST",
  });

  const [
    updateTemplate,
    {
      data: updateTemplateData,
      isLoading: updateTemplateLoading,
      error: updateTemplateError,
    },
  ] = UseLazyApiCallV2({
    url: "/update_template",
    method: "POST",
  });

  const [
    deleteTemplate,
    {
      data: deleteTemplateData,
      isLoading: deleteTemplateLoading,
      error: deleteTemplateError,
    },
  ] = UseLazyApiCallV2({
    url: "/delete_template",
    method: "POST",
  });

  const {
    data: templatesData,
    isLoading: templatesLoading,
    error: templatesError,
    refetch: refetchTemplates,
  } = UseApiCallV2({
    url: "/get_all_template",
    method: "POST",
    paramsData: { temp: "all" },
  });
  useEffect(() => {
    initialValuesForForm();
  }, [showNewTemplate, templatesData, current]);

  useEffect(() => {
    setCurrent(null);
    if (category) {
      const selectedOne = formFields?.find((item) => item.key === category);
      setCategoryNum(selectedOne?.id);
    }
  }, [category]);

  useEffect(() => {
    setReminderFormData((prev) => ({
      ...prev,
      title: "",
      description: "",
      subject: "",
    }));
    if (!templatesData?.templates) return;
    const totalTemplates = templatesData?.templates;

    const selectedOnes = totalTemplates?.filter(
      (item) => item?.category === category,
    );
    setSelectedCategoryTemplates(selectedOnes);

    // setCurrent(
    //   selectedOnes[0]?.id >= 0 ? JSON.stringify(selectedOnes[0]?.id) : "",
    // );
  }, [category, templatesData]);

  useEffect(() => {
    if (caseId) {
      fetchEmailReminders();
    }
  }, [caseId]);

  async function fetchEmailReminders() {
    const filters = {
      ...filtersData,
      dueDate: filtersData.dueDate
        ? filtersData.dueDate.replaceAll(".", "-")
        : null,
    };

    try {
      const res = await get_email_reminders({
        params: {
          case_id: caseId,
          filters,
        },
      });
      setReminders(res?.reminders || []);
    } catch (error) {
      console.log({
        error,
      });
    }
  }

  function initialValuesForForm() {
    if (!showNewTemplate) {
      const selectedTemplate = templatesData?.templates?.find(
        (item) => item?.id == current,
      );

      const { category, title, subject, description } = selectedTemplate || {};
      setReminderFormData((prev) => ({
        ...prev,

        category,
        title,
        subject,
        description,
      }));
    }
  }

  async function addNewTemplate(template_id) {
    const { description, email, name, subject, title } = reminderFormData;

    let params = {
      name,
      category,
      title,
      subject,
      description,
      email,
      createdBy: user?.email,
    };
    if (template_id && showNewTemplate) {
      params = { ...params, template_id };
    }
    const addOrUpdate = template_id ? updateTemplate : addTemplate;

    try {
      const res = await addOrUpdate({
        params,
      });
      if (res?.success) {
        message.success(res?.message);
        refetchTemplates();
        setShowNewTemplate(false);
        setReminderFormData({});
        setTemplateId(null);
      }
    } catch (error) {
      console.log({ error });
    }
  }

  const items = [
    {
      key: "sub1",
      label: `${categoryNum}. ${translator(`caseDetail.form.${category}`)}`,
      children: childrenForSidebar,
    },
  ];
  let inputFields = [
    {
      name: "title",
      title: reminderFormTrans.title,
      placeholder: "Enter title",
      type: "text",
    },
    {
      name: "subject",
      title: reminderFormTrans.subject,
      placeholder: "Enter subject",
      type: "text",
    },
    {
      name: "description",
      title: reminderFormTrans.description,
      placeholder: "Enter description",
      type: "text",
    },
  ];

  inputFields = showNewTemplate
    ? inputFields?.filter(
        (item) => item.name !== "name" && item.name !== "email",
      )
    : inputFields;

  const data = [
    {
      title: "After 1 day",
      key: "1d",
      keyForApi: "1d",
    },
    {
      title: "After 7 Days",
      key: "7d",
      keyForApi: "7d",
    },
    {
      title: "After 14 days",
      key: "14d",
      keyForApi: "14d",
    },
  ];
  const [activeOption, setActiveOption] = useState(data[0]);
  const [isDateSelected, setIsDateSelected] = useState();

  const sections = [{ title: null, items: data?.slice(0, 3) }];
  const onClick = (e) => {
    setCurrent(e.key);
  };

  function handleSelectOption(item) {
    setIsDateSelected();
    setActiveOption(item);
  }

  function onChangeInput(e) {
    const { name, value } = e.target;

    setReminderFormData({
      ...reminderFormData,
      [name]: value,
    });
  }
  function handleChangeTextEditor(content) {
    setReminderFormData((prev) => ({ ...prev, description: content }));
  }

  const onChangeDate = (date, dateString) => {
    setIsDateSelected(dateString);
    setActiveOption(null);
  };

  function handleSelectName(data) {
    const selectedEmail = employees?.find((item) => item.label === data).value;

    setReminderFormData((prev) => ({
      ...prev,
      name: data,
      email: selectedEmail,
    }));
    setError((prev) => ({ ...prev, name: false }));
  }
  function handleSelectEmail(data) {
    const selectedName = employees?.find((item) => item.value === data)?.label;
    setReminderFormData((prev) => ({
      ...prev,
      email: data,
      name: selectedName,
    }));
    setError((prev) => ({ ...prev, email: false }));
  }

  function handleSelectCategory(item) {
    setCategory(item);
  }

  async function handleDelete(id) {
    try {
      const res = await deleteTemplate({
        params: {
          template_id: id,
        },
      });
      if (res?.success) {
        message.success(res?.message);
        refetchTemplates();
      }
    } catch (error) {
      console.log({ error });
    }
  }
  function getFormateDate(date) {
    if (date) {
      if (date?.includes(".")) {
        const format = date?.replace(/\./g, "-");
        return dayjs(format, ["DD-MM-YYYY", "DD-MM-YY"], true);
      } else if (date?.includes("-")) {
        return dayjs(date);
      }
    }
  }

  async function handleSetReminder() {
    const { description, email, name, subject, title } = reminderFormData;

    if (!name) {
      setError((prev) => ({ ...prev, name: true }));
      return;
    }
    if (!email) {
      setError((prev) => ({ ...prev, email: true }));
      return;
    }

    const params = {
      email: user?.email,
      category,
      description: description || null,
      assigneeName: name,
      subject: subject || null,
      title: title || null,
      assigned_to: email,
      due_date: isDateSelected || activeOption?.keyForApi,
      isDate: !!isDateSelected,
      case_id: caseId,
      name: `${user?.firstName} ${user?.lastName}`,
    };

    try {
      const res = await setReminder({
        params,
      });
      if (res?.status === "Success") {
        message.success(res?.message);
        setReminderFormData({});
        refetchCount();
        fetchEmailReminders();
      }
    } catch (error) {
      console.log({ error });
    }
  }

  function onCloseTemplatePopup() {
    setShowNewTemplate(false);
    setTemplateId(null);
  }
  function showTemplatePopup() {
    setShowNewTemplate(true);
  }

  return (
    <Spin
      spinning={
        addTemplateLoading ||
        templatesLoading ||
        deleteTemplateLoading ||
        setReminderLoading
      }
    >
      <div style={{ padding: "0px 15px" }} className={styles.caseReminder}>
        <div className={styles.header}>
          <FileNumberSmile
            caseTotalStatuses={caseTotalStatuses}
            caseStatus={caseStatus}
            caseStatusLocal={caseStatusLocal}
            setCaseStatusLocal={setCaseStatusLocal}
          />
        </div>
        <Collapse
          style={{ marginBottom: "5px" }}
          activeKey={activeKey === "1" ? "1" : undefined}
          onChange={() => setActiveKey(activeKey === "1" ? null : "1")}
          expandIconPosition="end"
          expandIcon={({ isActive }) => (
            <AccordianDropdownArrow
              style={{
                fontSize: "16px",
                color: "#1890ff",
                transform: isActive ? "rotate(0)" : "rotate(180deg)",
              }}
            />
          )}
        >
          {/* Create a New Reminder */}
          <Collapse.Panel
            header={<h3>{reminderTrans.createReminder}</h3>}
            key="1"
          >
            <div className={styles.setReminderContainer}>
              <div style={{ margin: "15px 0" }}>
                <Select
                  showSearch
                  filterOption={(
                    input,
                    option, // 👈 filter logic
                  ) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  defaultValue={Fields[0]?.value}
                  value={category}
                  style={{ width: "100%", height: "40px" }}
                  onSelect={handleSelectCategory}
                  options={Fields}
                  suffixIcon={<DropdownSuffix />}
                />
              </div>
              <div className={styles.categoryAndReminderForm}>
                <div className={styles.categoryAndTemplates}>
                  <h4>{reminderTrans.suggestedTemplates}</h4>
                  <div className={styles.flex}>
                    <ConditionalRenderer
                      condition={selectedCategoryTemplates?.length < 1}
                    >
                      <h5
                        className={styles.flex}
                        style={{ alignItems: "center" }}
                      >
                        {translator("noTemplatesFound")}
                      </h5>
                    </ConditionalRenderer>
                    <div
                      className={styles.menuList}
                      style={{
                        pointerEvents:
                          showNewTemplate && !templateId ? "none" : "auto",
                      }}
                    >
                      <ConditionalRenderer
                        condition={selectedCategoryTemplates?.length > 0}
                      >
                        <Menu
                          onClick={onClick}
                          defaultOpenKeys={["sub1"]}
                          selectedKeys={[current]}
                          mode="inline"
                          items={items}
                        />
                      </ConditionalRenderer>
                    </div>
                    <ConditionalRenderer condition={!showNewTemplate}>
                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <button
                          className={styles.addTemplate}
                          onClick={() => {
                            setShowNewTemplate(true);
                          }}
                        >
                          <span>+</span> {reminderTrans.addTemplate}
                        </button>
                      </div>
                    </ConditionalRenderer>
                  </div>
                </div>
                <div className={styles.form}>
                  <div className={styles.inputFields}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div
                        className={styles.inputAndLabel}
                        style={{ width: "49%" }}
                      >
                        <div className={styles.label}>
                          {reminderFormTrans.name} <span>*</span>
                        </div>
                        <Select
                          status={error.name ? "error" : ""}
                          onClear={() =>
                            setReminderFormData((prev) => ({
                              ...prev,
                              name: null,
                              email: null,
                            }))
                          }
                          showSearch
                          onSelect={handleSelectName}
                          filterOption={(
                            input,
                            option, // 👈 filter logic
                          ) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          // defaultValue={employees[0]?.value}
                          style={{ width: "100%", height: "35px" }}
                          value={reminderFormData?.name}
                          // onChange={handleChange}
                          options={employees?.map((item) => ({
                            label: item?.label,
                            value: item?.label,
                          }))}
                          suffixIcon={<DropdownSuffix />}
                          placeholder="Select Name"
                          allowClear
                        />
                      </div>
                      <div
                        className={styles.inputAndLabel}
                        style={{ width: "49%" }}
                      >
                        <div className={styles.label}>
                          {reminderFormTrans.email} <span>*</span>
                        </div>

                        <Select
                          allowClear
                          onClear={() =>
                            setReminderFormData((prev) => ({
                              ...prev,
                              email: null,
                              name: null,
                            }))
                          }
                          status={error.email ? "error" : ""}
                          onSelect={handleSelectEmail}
                          showSearch
                          value={reminderFormData?.email}
                          filterOption={(
                            input,
                            option, // 👈 filter logic
                          ) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          // defaultValue={employees[0]?.value}
                          style={{ width: "100%", height: "35px" }}
                          // onChange={handleChange}
                          options={employees?.map((item) => ({
                            label: item?.value,
                            value: item?.value,
                          }))}
                          suffixIcon={<DropdownSuffix />}
                          placeholder="Select Email"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {inputFields.slice(1, 2).map((item) => (
                        <div style={{ width: "100%" }}>
                          <InputField
                            key={item.name}
                            placeholder={item.placeholder}
                            name={item.name}
                            title={item.title}
                            value={reminderFormData[item.name]}
                            type={item.type}
                            onChangeInput={onChangeInput}
                            handleChangeTextEditor={handleChangeTextEditor}
                            isQuill={item.name === "description"}
                          />
                        </div>
                      ))}
                    </div>
                    {inputFields.slice(2).map((item) => (
                      <InputField
                        key={item.name}
                        placeholder={item.placeholder}
                        name={item.name}
                        title={item.title}
                        value={reminderFormData[item.name]}
                        type={item.type}
                        onChangeInput={onChangeInput}
                        handleChangeTextEditor={handleChangeTextEditor}
                        isQuill={item.name === "description"}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <ConditionalRenderer condition={!showNewTemplate}>
              {/* <div className={styles.setReminder}>
              Set reminder for selected field
            </div> */}
              <div className={styles.selectFromOptions}>
                Wählen Sie aus den verfügbaren Optionen aus.
              </div>
              {sections?.map((section) => (
                <>
                  <ConditionalRenderer condition={section.title}>
                    <h3>{section.title}</h3>
                  </ConditionalRenderer>
                  <div className={styles.modalContainer}>
                    {section?.items?.map((item, index) => {
                      const isActive = item.key === activeOption?.key;

                      return (
                        <>
                          <div
                            className={`${styles.checkboxContainer} ${
                              isActive ? styles.activeCheckBox : ""
                            }`}
                            key={item.key}
                            onClick={() => handleSelectOption(item)}
                          >
                            <div
                              className={`${styles.radio} ${
                                isActive ? styles.activeRadio : ""
                              }`}
                            >
                              <ConditionalRenderer condition={isActive}>
                                <div className={styles.smallCircle} />
                              </ConditionalRenderer>
                            </div>
                            <div
                              className={`${styles.title} ${
                                isActive ? styles.activeTitle : ""
                              }`}
                            >
                              {reminderTrans[item.key]}
                            </div>
                          </div>
                        </>
                      );
                    })}
                    <DatePicker
                      inputReadOnly
                      placeholder={translator("selectDate")}
                      onChange={onChangeDate}
                      suffixIcon={<CalenderIcon />}
                      value={
                        isDateSelected ? getFormateDate(isDateSelected) : null
                      }
                      onFocus={() => setFocused(true)}
                      onBlur={() => setFocused(false)}
                      style={{
                        width: "20%",
                        border:
                          isDateSelected || focused
                            ? "2px solid #cd2a3f"
                            : "2px solid #ebeef4",
                      }}
                    />
                    <div className={`${styles.downloadBtnContainer}`}>
                      <button onClick={handleSetReminder}>
                        <span>{reminderTrans.setReminder}</span>
                      </button>
                    </div>
                  </div>
                </>
              ))}
            </ConditionalRenderer>
            <ConditionalRenderer condition={showNewTemplate}>
              <div className={styles.downloadBtnContainer}>
                <button
                  onClick={() => setShowNewTemplate(false)}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <span style={{ color: "#cd2a3f" }}>Cancel</span>
                </button>
                <button onClick={() => addNewTemplate(templateId)}>
                  <span>{templateId ? "Update" : "Save"}</span>
                </button>
              </div>
            </ConditionalRenderer>
          </Collapse.Panel>
        </Collapse>
        <ConditionalRenderer condition={!showNewTemplate}>
          <Collapse
            activeKey={activeKey === "2" ? "2" : undefined}
            onChange={() => setActiveKey(activeKey === "2" ? null : "2")}
            expandIconPosition="end"
            expandIcon={({ isActive }) => (
              <AccordianDropdownArrow
                style={{
                  fontSize: "16px",
                  color: "#1890ff",
                  transform: isActive ? "rotate(0)" : "rotate(180deg)",
                }}
              />
            )}
          >
            <Collapse.Panel
              header={<h3> {reminderTrans.reminderHistory} </h3>}
              key="2"
            >
              <Spin spinning={reminderHistoryLoading}>
                <ReminderHistoryTable
                  isLoading={reminderHistoryLoading}
                  refetchReminderHistory={fetchEmailReminders}
                  employees={employees}
                  refetchCount={refetchCount}
                  filtersData={filtersData}
                  setFiltersData={setFiltersData}
                  setReminders={setReminders}
                  reminders={reminders}
                />
              </Spin>
            </Collapse.Panel>
          </Collapse>
        </ConditionalRenderer>
      </div>
      <Modal
        destroyOnClose
        open={showNewTemplate}
        onCancel={() => setShowNewTemplate(false)}
        footer={null}
        title={
          <h2>
            {templateId
              ? reminderTrans.updateTemplate
              : reminderTrans.addTemplate}
          </h2>
        }
        centered
        width="100dvw"
        styles={{
          content: {
            backgroundColor: "#F5F6F8",
            borderRadius: "20px",
            height: "97dvh",
            overflowY: "auto",
          },
          header: { backgroundColor: "#F5F6F8" }, // turns the Modal red
        }}
      >
        <AddTemplate
          onCloseTemplatePopup={onCloseTemplatePopup}
          setTemplateId={setTemplateId}
          refetchTemplates={refetchTemplates}
          templateId={templateId}
          templatesData={templatesData}
          current={current}
          category={category}
        />
      </Modal>
    </Spin>
  );
};

export default CaseReminder;
